<template>
  <div>
    <form class="form-horizontal">
      <div class="row">
        <label class="ts-text-xs col-form-label col-md-4"
          >{{ $t('homework.date') }} :</label
        >
        <div class="col-md-8 text-left">
          <p class="mt-1">{{ resources.homework_date }}</p>
        </div>
      </div>
      <div class="row">
        <label class="ts-text-xs col-form-label col-md-4"
          >{{ $t('homework.class') }} :</label
        >
        <div class="col-md-8 text-left">
          <p class="mt-1">{{ resources.class_name }}</p>
        </div>
      </div>
      <div class="row">
        <label class="ts-text-xs col-form-label col-md-4"
          >{{ $t('homework.teacher') }} :</label
        >
        <div class="col-md-8 text-left">
          <p class="mt-1">{{ resources.teacher_name }}</p>
        </div>
      </div>
      <div class="row">
        <label class="ts-text-xs col-form-label col-md-4"
          >{{ $t('homework.subject') }} :</label
        >
        <div class="col-md-8 text-left">
          <p class="mt-1">{{ resources.subject_name }}</p>
        </div>
      </div>
      <div class="row">
        <label class="ts-text-xs col-form-label col-md-4"
          >{{ $t('homework.remark') }} :</label
        >
        <div class="col-md-8 text-left">
          <p class="mt-1">{{ resources.remarks }}</p>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-12">
          <span class="badge badge-primary mb-2">{{
            $t('homework.answer')
          }}</span>
          <div
            ref="drop_zone"
            id="drop_zone"
            class="ts-p-3 ts-border ts-rounded ts-border-dashed overflow-auto"
            :class="{
              'ts-bg-blue-300': is_drag_over,
              'ts-border-gray-300': !errors.has('attach_file_list'),
              'ts-border-red-300': errors.has('attach_file_list')
            }"
            v-cloak
            @drop.prevent="addFile"
            @dragover.prevent="() => (is_drag_over = true)"
            @dragleave.prevent="() => (is_drag_over = false)"
            @dblclick="$refs.input_submit_file.click()"
          >
            <span v-if="files.length == 0" class="ts-text-xs">{{
              $t('homework.dragDropHere')
            }}</span>
            <template v-for="(file, index) in files">
              <file-item
                :item="file"
                :key="index"
                :file-index="index"
                @remove="removeFile"
                @download="onDownload"
              />
            </template>
          </div>
          <div
            class="validate ts-text-xs"
            v-if="errors.has('attach_file_list')"
          >
            {{ errors.first('attach_file_list') }}
          </div>
          <input
            type="file"
            ref="input_submit_file"
            multiple
            @change="onClickFileChange"
            style="display:none"
          />
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-12">
          <textarea
            rows="3"
            class="form-control"
            :placeholder="$t('homework.remark')"
            v-model.trim="model.student_comment"
          ></textarea>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-right">
          <ts-button class="mr-2" @click.prevent="$emit('close')">{{
            $t('cancel')
          }}</ts-button>
          <ts-button
            color="primary"
            :waiting="waiting"
            @click.prevent="onSave"
            >{{ $t('save') }}</ts-button
          >
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import FileItem from './file-item'
import httpClient from '@/http-client'
import { Errors } from 'form-backend-validation'
import * as FileDownload from 'downloadjs'

export default {
  name: 'studentAnswerSheet',
  props: ['resources'],
  components: {
    FileItem
  },
  data() {
    return {
      waiting: false,
      is_drag_over: false,
      files: [],
      errors: new Errors(),
      model: {
        homework_id: 0,
        student_comment: '',
        attach_file_list: []
      }
    }
  },
  created() {
    this.model.homework_id = this.resources.homework_id
    this.setEditData()
  },
  computed: {
    selectedStudent() {
      return this.$store.state.selectedStudent.student_id
    }
  },
  methods: {
    onSave() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch(
          'eschool/parentHomework/store',
          Object.assign({}, this.model, { student_id: this.selectedStudent })
        )
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('close')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onClickFileChange(e) {
      let files = e.target.files
      this.files = [
        ...this.files,
        ..._.map(files, file => ({
          name: file.name,
          size: parseInt(file.size / 1024),
          type: file.type,
          progressing: 0,
          invalid_file: this.validate(file),
          file: file,
          uploaded: false,
          storage_path: null
        }))
      ]
      this.uploadFile()
    },
    addFile(e) {
      let droppedFiles = e.dataTransfer.files
      if (!droppedFiles) return
      this.files = [
        ...this.files,
        ..._.map(droppedFiles, file => ({
          name: file.name,
          size: parseInt(file.size / 1024),
          type: file.type,
          progressing: 0,
          invalid_file: this.validate(file),
          file: file,
          uploaded: false,
          storage_path: null
        }))
      ]
      this.is_drag_over = false
      this.uploadFile()
    },
    uploadFile() {
      _.forEach(
        this.files.filter(file => file.uploaded == false),
        (f, index) => {
          if (!this.validate(f.file)) {
            let frm = new FormData()
            frm.append('file', f.file)
            httpClient
              .post('/api/parent-homeworks/upload-files', frm, {
                onUploadProgress: el => {
                  if (el.lengthComputable) {
                    f.progressing = Math.round((el.loaded * 100) / el.total)
                  }
                }
              })
              .then(response => {
                f.uploaded = true
                f.storage_path = response.data.attach_file_path
                this.model.attach_file_list.push(
                  Object.assign({}, response.data)
                )
              })
              .catch(error => {
                this.$toasted.error(error.message)
              })
          }
        }
      )
    },
    removeFile({ index, record }) {
      record.progressing = 0
      let file_index = this.model.attach_file_list.indexOf(
        ...this.model.attach_file_list.filter(
          f => f.attach_file_path == record.storage_path
        )
      )
      this.model.attach_file_list[file_index].is_delete = true
      this.files.splice(index, 1)
    },
    validate(file) {
      let ALLOW_FILE = [
        'image/png',
        'image/jpeg',
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.ms-powerpoint',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/msword'
      ]

      if (file.size > 10000000 * 10 || !ALLOW_FILE.includes(file.type)) {
        return true
      }

      return false
    },
    setEditData() {
      if (this.resources.student_homework.length > 0) {
        this.model.student_comment = this.resources.student_homework[0].student_comments
        this.model.attach_file_list = this.resources.student_homework[0].student_answer
          .filter(f => f.attach_type_id == 3)
          .map(el => ({
            attach_file_name: el.original_file_name,
            attach_file_path: el.file_path,
            mime_type: el.mime_type,
            is_delete: false
          }))

        this.files = [
          ...this.files,
          ..._.map(
            this.resources.student_homework[0].student_answer.filter(
              f => f.attach_type_id == 3
            ),
            file => ({
              name: file.original_file_name,
              size: 0,
              type: file.mime_type,
              progressing: 100,
              invalid_file: false,
              file: null,
              uploaded: true,
              storage_path: file.file_path
            })
          )
        ]
      }
    },
    onDownload({ index, record }) {
      record.progressing = 0
      this.$store
        .dispatch('eschool/parentHomework/download', {
          filePath: record.storage_path.split('filePath=').pop()
        })
        .then(response => {
          record.progressing = 100
          FileDownload(response, record.name, record.type)
        })
        .catch(error => {
          let parese_error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(error))
          )
          this.$toasted.error(parese_error.message)
        })
        .finally(() => {
          record.action = false
        })
    }
  }
}
</script>

<style lang="css" scoped>
#drop_zone {
  min-height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
img {
  float: left;
  border-radius: 103px;
  padding: 3px;
  object-fit: cover;
  object-position: center;
  background: #fff7f7;
}
</style>
